import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

const THEME_KEY = 'bacheca.theme';
const LOCALE_KEY = 'bacheca.locale';

function initialTheme() {
  const saved = localStorage.getItem(THEME_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/* Tema, lingua e messaggi di stato.
 *
 * I messaggi hanno uno store perché prima non ce l'avevano: gli errori
 * finivano in `console.log` in dodici punti e l'utente non vedeva nulla —
 * in `PinCreateModal.savePin()` un PATCH fallito lasciava la modale aperta e
 * muta, e i due `fetchMore()` mangiavano l'errore facendo solo sparire lo
 * spinner.
 */
export const useUiStore = defineStore('ui', () => {
  const theme = ref(initialTheme());
  const locale = ref(localStorage.getItem(LOCALE_KEY) || null);
  const messages = ref([]);
  let nextId = 1;

  watch(
    theme,
    (value) => {
      document.documentElement.dataset.theme = value;
      localStorage.setItem(THEME_KEY, value);
    },
    { immediate: true },
  );

  watch(locale, (value) => {
    if (value) localStorage.setItem(LOCALE_KEY, value);
  });

  function toggleTheme() {
    theme.value = theme.value === 'dark' ? 'light' : 'dark';
  }

  function notify(text, kind = 'info', timeout = 4000) {
    const id = nextId++;
    messages.value.push({ id, text, kind });
    if (timeout) setTimeout(() => dismiss(id), timeout);
    return id;
  }

  const notifyError = (text) => notify(text, 'error', 6000);

  /** Aggiorna il testo di un toast persistente (progressi di un import). */
  function update(id, text) {
    messages.value = messages.value.map((m) => (m.id === id ? { ...m, text } : m));
  }

  function dismiss(id) {
    messages.value = messages.value.filter((m) => m.id !== id);
  }

  return { theme, locale, messages, toggleTheme, notify, notifyError, update, dismiss };
});
